import {useMutation, useQueryClient} from '@tanstack/react-query'
import {useSnackbar} from 'notistack'
import api from 'src/services/api'
import {PatchAlarmCenterZone} from 'src/services/api/endpoints/AlarmCenterEndpoint'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'
import handleErrorWithSnackbar from 'src/utilities/handleErrorWithSnackbar'

type UpdateAlarmCenterZoneInput = PatchAlarmCenterZone & {
  id: number
  cameraId: number
}

export default function useUpdateAlarmCenterZone() {
  const {enqueueSnackbar} = useSnackbar()
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: [QueryKeyEnum.UPDATE_ALARM_CENTER_ZONE],
    mutationFn: async ({id, cameraId: _cameraId, ...body}: UpdateAlarmCenterZoneInput) => {
      return (await api.alarmCenter.updateZone(id, body)).data.data
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({queryKey: [QueryKeyEnum.ALARM_CENTER_ZONES]})
      enqueueSnackbar('Zona atualizada com sucesso', {variant: 'success'})
    },
    onError: (error) => {
      handleErrorWithSnackbar(enqueueSnackbar, error, 'Não conseguimos atualizar a zona no momento')
    },
  })
}
